// extracted by mini-css-extract-plugin
export default {"root":"Card_root__fbeI7","pressable":"Card_pressable__F6hJ0","link":"Card_link__Kl46d","title":"Card_title__ZlfOl"};